import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { spacing } from "../../stitches.config";
import { Checkbox } from "../Inputs/react-hook-form";
import { StyledLink } from "./__styles__/Typography";
import { Section } from "./Layout";
import { Body } from "./Typography";

const TERMS_OF_USE_URL = "https://www.withforerunner.com/legal/terms-of-use";
const PRIVACY_POLICY_URL = "https://www.withforerunner.com/legal/privacy";

export const TermsOfUseInput = ({
  control,
  errors,
}: {
  control: Control<any>;
  errors: FieldErrors<any>;
}) => {
  const { t } = useTranslation();

  const termsOfUseLink = (
    <StyledLink href={TERMS_OF_USE_URL} target="_blank">
      {t("terms-of-use")}
    </StyledLink>
  );

  const privacyPolicyLink = (
    <StyledLink href={PRIVACY_POLICY_URL} target="_blank">
      {t("privacy-policy")}
    </StyledLink>
  );

  return (
    <>
      <Section flexDirection="row" gap={spacing.s}>
        <Checkbox
          name="terms"
          control={control}
          rules={{
            required: t("terms-of-use-required"),
          }}
        />
        <Body size="small" type="regular" color="contentPrimary">
          <Trans
            i18nKey="create-your-account-terms"
            components={{ termsOfUseLink, privacyPolicyLink }}
          />
        </Body>
      </Section>
      {errors.terms?.message && (
        <Body size="small" type="regular" color="contentCritical">
          {errors.terms.message as string}
        </Body>
      )}
    </>
  );
};
